import React from "react";
import { Route } from "react-router-dom";

import ConfigureDevicePage from "cortex/ui/src/fleet/view/device/ConfigurePage";
import BulkDeviceEdit from "cortex/ui/src/fleet/view/device/component/BulkDeviceEdit";
import DeviceEdit from "cortex/ui/src/fleet/view/device/DeviceEdit";
import DeviceFlagsPage from "cortex/ui/src/fleet/view/device/DeviceFlagsPage";
import DeviceView from "cortex/ui/src/fleet/view/device/DeviceView";
import FullDeviceList from "cortex/ui/src/fleet/view/device/FullDeviceList";

function renderDeviceRoutes() {
  return [
    <Route
      component={FullDeviceList}
      exact
      key="device-list"
      path={["/devices"]}
    />,
    <Route
      component={DeviceFlagsPage}
      exact
      key="device-flags"
      path="/devices/:deviceId/flags"
    />,
    <Route
      component={BulkDeviceEdit}
      exact
      key="bulk-device-edit"
      path="/devices/bulk-edit"
    />,
    <Route
      component={ConfigureDevicePage}
      exact
      key="device-configure"
      path="/devices/:deviceId/configure"
    />,
    <Route
      component={DeviceEdit}
      exact
      key="device-edit"
      path={`/devices/:deviceId/edit`}
    />,
    <Route
      component={DeviceView}
      key="device-view::tab"
      path="/devices/:id/:activeTab?"
    />,
  ];
}

export { renderDeviceRoutes };
